/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import {AuthenticateParams, identityAuthorisePost} from "../fn/identity/authorise-post";
import {TokenModel} from "../models/token-model";
import {enable2faPost, Enable2faPostParams} from "../fn/identity/enable-2fa-post";
import {initialise2faPost} from "../fn/identity/initialise-2fa-post";
import {TotpAuthenticatorModel} from "../models/totp-authenticator-model";
import {resetPasswordPost, ResetPasswordPostParams} from "../fn/identity/reset-password-post";
import {forgotPasswordPost, ForgotPasswordPostParams} from "../fn/identity/forgot-password-post";
import {identityRefreshPost, RefreshParams} from "../fn/identity/refresh-post";
import {identityLogoutPost, LogoutParams} from "../fn/identity/logout-post";

@Injectable({ providedIn: 'root' })
export class IdentityService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http);
    }

    /** Path part for operation `authenticatePost()` */
    static readonly authenticatePostPath = '/api/v1/identity/authenticate';

    /**
     * Authenticate user and return tokens
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `authenticatePost()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    authenticatePost$Response(params: AuthenticateParams, context?: HttpContext): Observable<StrictHttpResponse<TokenModel>> {
        return identityAuthorisePost(this.http, this.rootUrl, params, context);
    }

    /**
     * Authenticate user and return tokens
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `authenticatePost$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    authenticatePost(params: AuthenticateParams, context?: HttpContext): Observable<TokenModel> {
        return this.authenticatePost$Response(params, context).pipe(
            map((r: StrictHttpResponse<TokenModel>): TokenModel => r.body)
        );
    }

    /**
     * Enables 2FA for a user using a valid 2FA code
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    enable2faPost$Response(headers: HttpHeaders, params: Enable2faPostParams, context?: HttpContext): Observable<StrictHttpResponse<void>> {
        return enable2faPost(headers, this.http, this.rootUrl, params, context);
    }

    /**
     * Initialises 2FA for a user using google authenticator, and returns a b64 image url and a manual entry code
     * in order for users to set up the mfa codes on their device
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    initialise2faPost$Response(headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<TotpAuthenticatorModel>> {
        return initialise2faPost(headers, this.http, this.rootUrl, context);
    }

    /**
     * Resets a users password using a code that was sent to their email address
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    resetPasswordPost$Response(params: ResetPasswordPostParams, context?: HttpContext): Observable<StrictHttpResponse<void>> {
        return resetPasswordPost(this.http, this.rootUrl, params, context);
    }

    /**
     * Sends a forgot password email and initiates the reset password process if the user exists
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    forgotPasswordPost$Response(params: ForgotPasswordPostParams, context?: HttpContext): Observable<StrictHttpResponse<void>> {
        return forgotPasswordPost(this.http, this.rootUrl, params, context);
    }

    /**
     * Refreshes an expired token using a refresh token
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    refreshPost$Response(params: RefreshParams, context?: HttpContext): Observable<StrictHttpResponse<TokenModel>> {
        return identityRefreshPost(this.http, this.rootUrl, params, context);
    }

    /**
     * Revokes a users refresh token, so that it cannot be used to generate more access tokens
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    logoutPost$Response(params: LogoutParams, context?: HttpContext): Observable<StrictHttpResponse<void>> {
        return identityLogoutPost(this.http, this.rootUrl, params, context);
    }
}
